class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    //this.header = document.querySelector('sticky-header');
    //this.onBodyClick = this.handleBodyClick.bind(this);
    //this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
     //this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
     //closeButton.addEventListener('click', this.close.bind(this))
    //);
    //document.getElementsByClassName("cart-logo")[0].addEventListener("click", this.open.bind(this));   
  }
  
//   open() {
//    this.notification.classList.add('animate', 'active');
//     this.notification.addEventListener('transitionend', () => {
//       this.notification.focus();
//       trapFocus(this.notification);
//     }, { once: true });
//     document.body.addEventListener('click', this.onBodyClick);
//   }

//   close() {
//     this.notification.classList.remove('active');
//     document.body.removeEventListener('click', this.onBodyClick);
//     removeTrapFocus(this.activeElement);
//   }

  renderContents(parsedState) {
      document.getElementById("cart-notification-default").innerHTML="";
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
    
    //document.getElementsByClassName("cart-logo")[0].addEventListener("click", this.open.bind(this));
	var dropDownIcon = document.querySelector('#cart-icon-bubble');
    if(dropDownIcon.getAttribute("aria-expanded") == "false")
    {
    	dropDownIcon.click();
    }      
    //if (this.header) this.header.reveal();
    //this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
       // selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// Custom Code By Alvy
// ==========================
// SAFE CART FETCH
// ==========================

let cartRequest = null;

function getCartSafe() {

  // Prevent multiple simultaneous requests
  if (cartRequest) return cartRequest;

  cartRequest = fetch('/cart.js', {
    credentials: 'same-origin'
  })
    .then(res => {
      if (!res.ok) {
        throw new Error('Cart fetch failed');
      }

      return res.json();
    })
    .catch(err => {
      console.warn('Cart fetch skipped:', err.message);
      return null;
    })
    .finally(() => {
      // release request lock
      setTimeout(() => {
        cartRequest = null;
      }, 100);
    });

  return cartRequest;
}

// ==========================
// FREE SHIPPING BAR
// ==========================

function updateFreeShippingBar() {

  const wrapper = document.querySelector('.free-shipping-wrapper');

  if (!wrapper) {
    return Promise.resolve();
  }

  const threshold = parseInt(wrapper.dataset.threshold || 0);

  const msg = wrapper.querySelector('.free-msg');
  const fill = wrapper.querySelector('.free-progress-fill');
  const cartIcon = wrapper.querySelector('.cart-icon');

  return getCartSafe().then(cart => {

    if (!cart) return;

    const total = cart.total_price || 0;

    const remaining = Math.max(threshold - total, 0);

    const percentage = threshold > 0
      ? Math.min((total / threshold) * 100, 100)
      : 0;

    // update progress bar
    fill.style.width = percentage + '%';

    // update cart icon position
    cartIcon.style.right = (percentage - 8) + '%';
    cartIcon.style.opacity = '1';

    // FREE SHIPPING REACHED
    if (total >= threshold && threshold > 0) {

      msg.innerHTML = "יססס! קיבלת משלוח חינם!";

      wrapper.classList.add('free-done');

      cartIcon.style.right = '100%';
      cartIcon.style.opacity = '0';
    }

    // EMPTY CART
    else if (total === 0) {

      msg.innerHTML =
        "🚚 הוסיפו לסל עוד מוצרים וקבלו משלוח חינם!";

      wrapper.classList.remove('free-done');

      cartIcon.style.right = '0';
      cartIcon.style.opacity = '1';
    }

    // NORMAL STATE
    else {

      msg.innerHTML =
        "הוסיפו עוד " +
        (remaining / 100).toFixed(0) +
        "₪ וקבלו משלוח חינם!";

      wrapper.classList.remove('free-done');
    }
  });
}

// ==========================
// UPSELL VISIBILITY
// ==========================

function upsellHide() {

  const drawesell = document.querySelector('.cartDrawerUpsell');

  if (!drawesell) {
    return Promise.resolve();
  }

  return getCartSafe().then(cart => {

    if (!cart) return;

    drawesell.style.display =
      cart.item_count > 0
        ? 'block'
        : 'none';
  });
}

// ==========================
// SAFE CART UI REFRESH
// ==========================

let cartTimeout;
let isUpdatingCartUI = false;

function triggerCartUpdate() {

  // Prevent recursive loops
  if (isUpdatingCartUI) return;

  isUpdatingCartUI = true;

  clearTimeout(cartTimeout);

  cartTimeout = setTimeout(() => {

    Promise.all([
      updateFreeShippingBar(),
      upsellHide()
    ])
      .finally(() => {

        // release lock after updates finish
        setTimeout(() => {
          isUpdatingCartUI = false;
        }, 200);
      });

  }, 300);
}

// ==========================
// SHOPIFY / AJAX EVENTS
// ==========================

[
  'cart:updated',
  'ajaxProduct:added',
  'cart:update',
  'cart:change'
].forEach(evt => {

  document.addEventListener(evt, triggerCartUpdate);

});

// ==========================
// MUTATION OBSERVER
// ==========================

const cartDrawer = document.querySelector('#cart-notification');

if (cartDrawer) {

  const observer = new MutationObserver((mutations) => {

    // Ignore updates inside free shipping bar
    const relevantMutation = mutations.some(mutation => {

      return !mutation.target.closest('.free-shipping-wrapper');

    });

    if (!relevantMutation) return;

    triggerCartUpdate();
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

// ==========================
// CLICK FALLBACK
// ==========================

document.body.addEventListener('click', e => {

  if (e.target.closest('#cart-notification')) {

    setTimeout(() => {

      triggerCartUpdate();

    }, 500);
  }
});

// ==========================
// UPSELL RELOAD
// ==========================

let upsellReloading = false;

function reloadUpsell() {

  // prevent multiple reloads
  if (upsellReloading) return;

  upsellReloading = true;

  fetch('/?section_id=cart-upsell')
    .then(res => res.text())

    .then(html => {

      const temp = document.createElement('div');

      temp.innerHTML = html;

      const newContent =
        temp.querySelector('#cart-upsell-wrapper');

      const current =
        document.querySelector('#cart-upsell-wrapper');

      if (newContent && current) {

        // only replace if changed
        if (current.innerHTML !== newContent.innerHTML) {

          current.innerHTML = newContent.innerHTML;
        }
      }
    })

    .catch(err => {

      console.error('Upsell error:', err);

    })

    .finally(() => {

      setTimeout(() => {

        upsellReloading = false;

      }, 300);
    });
}

// ==========================
// INITIAL LOAD
// ==========================

document.addEventListener('DOMContentLoaded', function () {

  triggerCartUpdate();

  reloadUpsell();
});

// ==========================
// ADD TO CART RELOAD
// ==========================

document.addEventListener('click', function (e) {

  const btn = e.target.closest(
    '.ajax-add-to-cart, ' +
    '.add-to-cart-js, ' +
    '#qv-add-to-cart, ' +
    '.bundle-add-to-cart, ' +
    '.bundle-add-to-cart2'
  );

  if (!btn) return;

  // wait for Shopify AJAX cart update
  setTimeout(() => {

    triggerCartUpdate();

    reloadUpsell();

  }, 1000);
});

document.addEventListener('DOMContentLoaded', function () {
    const removeButtons = document.querySelectorAll('.cart-remove-js');
    removeButtons.forEach(button => {
        button.addEventListener('click', function () {
            this.classList.add('loading');
        });
    });
});